<template>
    <div>
        <div class="d-flex align-center">
            <v-text-field
                    v-model="search"
                    class="datatable-search"
                    dense
                    hide-details
                    outlined
                    prepend-inner-icon="mdi-magnify"/>
            <div v-if="isAdmin" class="ml-4">
                <router-link :to="{name: 'addZone'}">
                    <v-btn class="accent" icon rounded @click="openAddEditDialog = true">
                        <v-icon color="accentText">mdi-plus</v-icon>
                    </v-btn>
                </router-link>
            </div>
        </div>
        <v-data-table
                :headers="header"
                :items="filterItems"
                :loading="loading"
                :search="search"
                class="rounded-lg shadow my-6">
            <template v-slot:[`item.actions`]="{ item }">
                <TableAction v-if="isAdmin" :tooltip="$t('tooltips.editZone')" icon="mdi-pencil"
                             @click="editZone(item.ZoneID)"/>
                <router-link :to="{name: 'zoneManagement', params: {id: item.ZoneID}}">
                    <TableAction v-if="isAdmin" :tooltip="$t('zones.zoneManagement')" icon="mdi-cog"/>
                </router-link>
                <router-link v-if="isAdmin" :to="{name: 'geofenceHistory', params: {id: item.ZoneID}}">
                    <TableAction :tooltip="$t('zones.geofenceHistory')" icon="mdi-clipboard-text-clock"/>
                </router-link>
                <TableAction v-if="isAdmin" :tooltip="$t('tooltips.sendNotification')"
                             icon="mdi-bell-badge"
                             @click="sendNotificationToZone(item.ZoneID)"/>
                <TableAction v-if="isAdmin" :tooltip="$t('tooltips.delete')" icon="mdi-delete"
                             @click="deleteItem(item.ZoneID)"/>
            </template>
            <template v-slot:[`header.Type`]>
                <FilterDropDown
                        v-model="filters.zoneTypes"
                        :available-values="Array.from(availableValues.zoneTypes)"
                        :filter-values="zoneTypes"
                        :name="$t('zones.type')"/>
            </template>
            <template v-slot:[`item.Type`]="{item}">
                {{ getZoneName(item.Type) }}
            </template>
        </v-data-table>
        <DeleteDialog ref="deleteDialog"/>
    </div>
</template>

<script>
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog";
import FilterDropDown from "@/components/reusable/FilterDropDown/FilterDropDown";

export default {
  name: "MyZones",
  components: {
    FilterDropDown,
    DeleteDialog
  },
  mounted() {
    this.initItems();
    window.addEventListener('keyup', this.handleKeyup);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.handleKeyup);
  },
  data() {
    return {
      search: '',
      loading: true,
      items: [],
      openAddEditDialog: false,
      openInviteDialog: false,
      loadingInvitation: false,
      validMail: false,
      emailInvitation: '',
      circleID: '',
      circleName: '',
      filters: {
        zoneTypes: [],
      },
      availableValues: {
        zoneTypes: new Set(),
      },
    };
  },
  computed: {
    filterItems() {
      return this.items.filter(item => this.filters.zoneTypes.includes(item.Type));
    },
    header() {
      return [
        {text: this.$t('zones.zoneName'), value: 'Name'},
        {text: this.$t('zones.type'), value: 'Type'},
        {text: '', value: 'actions', sortable: false, width: 200}
      ];
    },
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    isAdmin() {
      return this.$store.getters.isOrganizationAdmin;
    },
    zoneTypes() {
      return [
        {
          value: 'Normal',
          text: this.$t("zones.normal"),
        },
        {
          value: 'Safe',
          text: this.$t("zones.safe"),
        },
        {
          value: 'Warning',
          text: this.$t("notifications.warning"),
        },
        {
          value: 'Danger',
          text: this.$t("zones.danger"),
        },
      ];
    },
  },
  methods: {
    initItems() {
      this.loading = true;
      const url = this.$store.getters.zones;
      this.axios.get(url).then(({data}) => {
        this.items = data.Result;
        this.items.forEach(item => {
          this.availableValues.zoneTypes.add(item.Type);
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    editZone(id) {
      this.$router.push({
        name: 'editZone', params: {
          id: id
        }
      });
    },
    deleteItem(zoneID) {
      this.$refs.deleteDialog.openDialog().then(result => {
        if (result) {
          const url = this.$store.getters.zone(zoneID);
          this.$store.dispatch('setLoader', true);
          this.axios.delete(url).then(() => {
            this.initItems();
          }).finally(() => {
            this.$store.dispatch('setLoader', false);
          });
        }
      });
    },
    inviteUser() {
      this.openInviteDialog = true;
    },
    editCircleName(circleID, circleName) {
      this.circleID = circleID;
      this.circleName = circleName;
      this.openAddEditDialog = true;
    },
    closeAddEditDialog() {
      this.openAddEditDialog = false;
      this.circleID = '';
      this.circleName = '';
    },
    sendNotificationToZone(zoneID) {
      this.$router.push({name: 'sendNotifications', params: {zoneID: zoneID}});
    },
    getZoneName(zoneType) {
      return this.zoneTypes.filter(type => type.value === zoneType)[0].text;
    },
    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.$router.back();
      }
    }
  }
};
</script>

<style scoped>

</style>